import React from 'react';
import PropTypes from 'prop-types';

import ModalComponent from 'components/ModalComponent';

const AppointmentCancelConfirm = (
  {
    id,
    first_name,
    last_name,
    email,
    phone,
    onCancel
  }
) => {
  const buttons = [
    <button
      className='btn btn-danger'
      type='button'
      onClick={() => onCancel(id)}
    >
      Cancel Appointment
    </button>
  ];

  return (
    <ModalComponent title='Cancel Appointment' buttons={buttons}>
      <strong>Are you sure you want to cancel this appointment?</strong>
      If you wish to notify the person who booked the appointment, please use the below information:


      <div className='appointment-cancel-modal-contact-info'>
        <div className='appointment-cancel-modal-label'>Name:</div>
        <div className='appointment-cancel-modal-value'>{`${first_name} ${last_name}`}</div>
      </div>

      <div className='appointment-cancel-modal-contact-info'>
        <div className='appointment-cancel-modal-label'>Phone:</div>
        <div className='appointment-cancel-modal-value'>{phone}</div>
      </div>

      <div className='appointment-cancel-modal-contact-info'>
        <div className='appointment-cancel-modal-label'>Email:</div>
        <div className='appointment-cancel-modal-value'>{email}</div>
      </div>
    </ModalComponent>
  );
};

AppointmentCancelConfirm.propTypes = {
  /** The ID of the appointment to be cancelled */
  id: PropTypes.string,

  /** The first name of the contact */
  first_name: PropTypes.string,

  /** The last name of the contact */
  last_name: PropTypes.string,

  /** The email address of the contact */
  email: PropTypes.string,

  /** The phone number of the contact */
  phone: PropTypes.string,

  /** Method called when the "cancel" button is clicked */
  onCancel: PropTypes.func
};

AppointmentCancelConfirm.defaultProps = {
  id: '',
  first_name: '',
  last_name: '',
  email: '',
  phone: '',

  onCancel: () => false
};

export default AppointmentCancelConfirm;
